import { useTranslation } from 'next-i18next'

import RetakeButton from '~/bootcamp/pages/BootcampView/BootcampContent/RetakeButton'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function SetCompletedScore({
  correctPercent,
  isEndOfLevel,
  nextButton,
}: {
  correctPercent: number
  isEndOfLevel?: boolean
  nextButton: React.ReactElement
}): React.ReactElement {
  const { t } = useTranslation('bootcamp')
  const isRightPercentage = correctPercent > 0
  const text = correctPercent > 75 || !isRightPercentage ? t('goodJob') : t('youCanDoBetter')

  return (
    <div className="text-center w-full z-20 h-2/5">
      <ResponsiveImage
        className="absolute w-full bottom-44 md:bottom-20 left-0 right-0 mx-auto z-10"
        height={300}
        srcKey="bootcamp/reward-bg.svg"
        width={610}
      />
      <div className="relative z-20 font-semibold text-white">
        {isEndOfLevel ? (
          <div className="mb-1 md:mb-10">
            {isRightPercentage && (
              <h3 className="text-lg md:text-h3 mb-1 md:mb-2">{t('correctPercentage', { percent: correctPercent })}</h3>
            )}
            <p className="text-md md:text-xl">{t('welldone')}</p>
          </div>
        ) : (
          <div className="mb-1 md:mb-5 -mt-2 md:mt-0 text-md md:text-lg">
            {isRightPercentage && (
              <>
                <p>{t('youGot')}</p>
                <h3 className="text-lg md:text-h3">{t('correctPercentage', { percent: correctPercent })}</h3>
              </>
            )}
            <p>{text}</p>
          </div>
        )}
        <div className="flex flex-col md:flex-row justify-center items-center mx-8 gap-4 mb-4 md:mb-8 text-xs">
          <RetakeButton />
          {nextButton}
        </div>
      </div>
    </div>
  )
}
